module.exports = __webpack_public_path__ + "img/dcmm_9.ecf99256.png";